export default __webpack_public_path__ + "static/media/Kingdom.09dc5d91.svg";